export const simpleDeepClone = <ObjectType>(object: ObjectType): ObjectType =>
  JSON.parse(JSON.stringify(object));

export type AtLeastOneKeyRequired<T> = {
  [K in keyof T]-?: Partial<T> & Pick<T, K>;
}[keyof T];

export const isObject = (value: unknown): value is object =>
  value !== null && typeof value === "object";
